export default __webpack_public_path__ + "static/media/Group8861.bb7667c0.svg";